'use client';

import React from 'react';

import { getCookie } from 'cookies-next/client';

import {
  HOMEPAGE_MINIMUM_PRODUCTS,
  HOMEPAGE_MAX_PRODUCTS,
} from './constants.ts';

import { RecentSearchesPlaceholder } from '@/app/[locale]/(home)/components/RecentSearches/RecentSearchesPlaceholder';
import { RecentSearchesUi } from '@/app/[locale]/(home)/components/RecentSearches/RecentSearchesUi';
import { RECENT_SEARCH_VAL } from '@/constants/cookies';
import { getProductsFromPaginatedResponse } from '@/modules/product/helpers/getProductsFromPaginatedResponse.ts';
import { SearchFrom } from '@/modules/search/types.ts';
import { useProductsSearch } from '@/modules/search/useProductsSearch.ts';

export function RecentSearchesModule() {
  const searchInput = getCookie(RECENT_SEARCH_VAL);
  const searchFilters = { isDiscounted: false };

  const { data, isLoading } = useProductsSearch({
    searchInput,
    searchFilters,
    itemsPerPage: HOMEPAGE_MAX_PRODUCTS,
    from: SearchFrom.RecentSearch,
    includeBoostedListings: false,
  });

  if (!searchInput) {
    return null;
  }

  if (isLoading) {
    return <RecentSearchesPlaceholder />;
  }

  const products = getProductsFromPaginatedResponse(data);

  const hasProducts = products && products.length >= HOMEPAGE_MINIMUM_PRODUCTS;

  if (!hasProducts) {
    return null;
  }

  return <RecentSearchesUi searchTerm={searchInput} products={products} />;
}

export function RecentSearches() {
  return <RecentSearchesModule />;
}
